
/* injects from baggage-loader */
var Template = require('./template.js');

import { Component } from 'react';
import { connect } from "react-redux";
import {createSelector} from 'reselect';
import { SwarmDataMixin } from '../../../mixins/swarmDataMixin';
import { LoyalCard } from '../../../actions/terminal';
import { UIMixin } from '../../../mixins/uiMixin';

class LoyalCardPopup extends Component {
    constructor (props) {
        super(props);
        this.deleteTheCard = this.deleteTheCard.bind(this);
    }

    deleteTheCard () {
        this.props.dispatch(LoyalCard(null));
        this.props.closePopup()();
    }
    render () {
        // eslint-disable-next-line no-undef
        return Template.default.apply(this);
    }
}
const mapStateToProps = (_) => {
    return createSelector(
        [
            state => state.terminal.loyalCard && state.terminal.loyalCard.result
        ],
        (loyalCard) => {
            return {
                loyalCard
            };
        }
    );
};
export default connect(mapStateToProps)(SwarmDataMixin({Component: UIMixin({Component: LoyalCardPopup})}));